import { jsx as _jsx } from "react/jsx-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import FaqRowItem from './FaqRowItem';
import { useTranslation } from 'react-i18next';
const SortableFaqRowItem = ({ faq, onDelete, onEdit, onSelect }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: faq.id });
    const { i18n } = useTranslation();
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };
    const currentLangCode = i18n.language?.toLowerCase();
    const translation = faq.translations?.find(t => t.languageCode?.toLowerCase() === currentLangCode);
    const displayQuestion = translation?.question || faq.question;
    const displayAnswer = translation?.answer || faq.answer;
    return (_jsx(Box, { ref: setNodeRef, style: style, children: _jsx(FaqRowItem, { question: displayQuestion, answer: displayAnswer, isLoading: faq.isLoading, dragHandleProps: { ...attributes, ...listeners }, onDelete: () => onDelete(faq.id), onEdit: () => onEdit(faq.id), onClick: () => onSelect(faq) }) }));
};
export default SortableFaqRowItem;
